import apiCommonCategory from "@/api/common-category";
import {post} from "@/utils/request";

export default class apiBkDownloadTask extends apiCommonCategory{
  static module = "bk_download_task";

  static async getInfo(){
    return post('/home/bk_download_task/getInfo')
  }

  static async save(data){
    return post('/home/bk_download_task/save', data)
  }

  static async listDel(ids) {
    return post('/home/bk_download_task/listDel', { ids })
  }

  static async downMarc(id){
    return post('/home/bk_download_task/downMarc', { id })
  }

  static async downloadSuccessItems(id){
    return post('/home/bk_download_task/downloadSuccessItems', { id })
  }

  static async createFromOrder(orderId){
    return post('/home/bk_download_task/createFromOrder', { orderId })
  }
}
